import React, { useEffect, useRef } from 'react'
import { Ref, Container, Menu, Segment } from 'semantic-ui-react'
import { ThemeProvider } from 'styled-components'
import { GlobalStyles } from "../../components/GlobalStyles/GlobalStyles"
import { lightTheme, darkTheme } from "../../components/Theme/Theme";
import { useDarkMode } from "../../hooks/useDarkMode/useDarkMode";
import { useSelector, useDispatch } from 'react-redux';
import { SetFixed, SetShowSearchBox } from "../../../../redux/actions/mainActions"
import NavigationBar from "../../containers/HomeLayout/NavigationBar/NavigationBar"
import Footer from '../../components/Footer/Footer';
import HomePage from '../../pages/HomePage/HomePage';
import "./HomeLayout.css"
import AppBar from '../../containers/HomeLayout/AppBar/AppBar';
const HomeLayout = ({ children }) => {
  const [theme, themeToggler] = useDarkMode();
  const themeMode = theme === "light" ? lightTheme : darkTheme;
  const dispatch = useDispatch()
  useEffect(() => {
    window.onscroll = function () {
      if (window.pageYOffset === 0) {
        dispatch(SetFixed(false))
        dispatch(SetShowSearchBox(false))

      }
      if (window.pageYOffset > 0) {
        dispatch(SetFixed(true))

      }
    };
  })

  return <div className="mobile-view">
    <ThemeProvider theme={themeMode}>
      <GlobalStyles />
      <NavigationBar />
      <HomePage />
      <AppBar/>
      <div className="bg-light-grey p-1 border-1px-top">
        <Footer />
      </div>
    </ThemeProvider>
  </div>
}
export default HomeLayout